// extracted by mini-css-extract-plugin
export var header = "OfferHighlights-module--header--0596d";
export var offers = "OfferHighlights-module--offers--d90df";
export var title = "OfferHighlights-module--title--5c333";
export var variantLarge = "OfferHighlights-module--variant-large--87277";
export var variantSmall = "OfferHighlights-module--variant-small--50910";